// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-4eafc468]{position:fixed}[data-v-4eafc468] .v-application--wrap{min-height:-moz-fit-content;min-height:fit-content;width:100%;display:block;flex:initial;flex-direction:row}", ""]);
// Exports
module.exports = exports;
